import { render, staticRenderFns } from "./reviewer-training-preview.component.vue?vue&type=template&id=1edc09b2"
import script from "./reviewer-training-preview.component.ts?vue&type=script&lang=ts&external"
export * from "./reviewer-training-preview.component.ts?vue&type=script&lang=ts&external"
import style0 from "./reviewer-training-preview.component.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports